import assign from 'object-assign';
// Create a "Class" object on window that all classes will extend from
var initializing = false,
    fnTest = /xyz/.test( function () {
        xyz;
    } ) ? /\b_super\b/ : /.*/;

// The base Class implementation (does nothing)
var Class = function () {};

// Create a new Class that inherits from this class
Class.extend = function clazz ( prop ) {
    var prop = prop || {},
        _super = this.prototype;

    // Instantiate a base class (but only create the instance,
    // don't run the init constructor)
    initializing = true;
    var prototype = new this();
    initializing = false;

    // Copy the properties over onto the new prototype
    for ( var name in prop ) {
        // Check if we're overwriting an existing function
        prototype[name] =
            typeof prop[name] == 'function' && typeof _super[name] == 'function' && fnTest.test( prop[name] ) ?
                (function ( name, fn ) {
                    return function () {
                        var tmp = this._super;

                        // Add a new ._super() method that is the same method
                        // but on the super-class
                        this._super = _super[name];

                        // The method only need to be bound temporarily, so we
                        // remove it when we're done executing
                        var ret = fn.apply( this, arguments );
                        this._super = tmp;

                        return ret;
                    };
                })( name, prop[name] ) :
                prop[name];
    }

    // bootstrap private and public initializers
    prototype._initialize = function () {
        var no_errors = true;
        if ( !initializing ) {
            // private initialization method
            // used by SuperClass to setup internal properties, validate execution environment and halt init if errors occur
            // eg. if required element does not exist in env, returns false
            if ( this.__init__ ) {
                no_errors = this.__init__.apply( this, arguments );
            }
        }

        if ( this.init && no_errors ) {
            this.init.apply( this, arguments );
        }
    };

    // The dummy class constructor
    function Class () {
        var args = arguments;
        this._initialize.apply( this, args );

        var self = this;
        this.reinitialize = function () {
            self._initialize.apply( self, args );
        };
    }

    // Populate our constructed prototype object
    Class.prototype = prototype;

    // Enforce the constructor to be what we expect
    Class.prototype.constructor = Class;

    // And make this class extendable
    // Class.extend = arguments.callee; // !deprecated: does not work in "strict mode"
    Class.extend = clazz;

    // Add static methods to class eg. Person.find(1)
    Class.define_class_properties = function ( obj ) {
        var obj = obj || {};

        assign( this, obj );

        // call static properties extended callback if exists
        if ( obj.hasOwnProperty( 'extended' ) ) {
            obj.extended( this );
        }
    };
    // call instance properties extended callback if exists
    if ( prop.hasOwnProperty( 'extended' ) ) {
        prop.extended( this );
    }

    return Class;
};

export default Class;
